<fgb-banner [pageTitle]="'contact.us.page.title' | translate"></fgb-banner>
<fgb-page-header [pageTitle]="'contact.us.page.title'" [showBalance]="false" [showFooter]="true" [backButtonLink]="'/'" />
<div class="margin-30">
  <fgbcl-contact-us></fgbcl-contact-us>
</div>
